import { LayoutService } from 'src/app/layout/layout.service';
import { Component, OnInit } from '@angular/core';
import { PageHeader } from 'src/app/models/page-header';

@Component({
  selector: 'app-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.less']
})
export class PageHeaderComponent implements OnInit {
  pageHeader: PageHeader;
  constructor(private layoutService: LayoutService) { }

  ngOnInit(): void {
    this.layoutService.pageHeaderChanged.subscribe((d: PageHeader) => {
      this.pageHeader = d;
    });
  }

}
